require("fslightbox");
import initializeProductOverview from "../components/02-components/product-overview/product-overview";
import initializeCart from "../components/02-components/cart/cart";
import initializeHeaderSubnav from "../components/02-components/header/header";
import initializeGtmTracking from "../components/60-tracking/01-gtm-tracking-main";
import initializeProductDetail from "../components/02-components/product-detail/product-detail";
import initializeCheckout from "../components/02-components/checkout/checkout";
import initializeSearch from "../components/02-components/search/search";

"use strict";
//
// All component javascript libraries should be included here as the
// demo component has been included for example.
// As the demo component is just included for demonstration purposes it should
// be removed at some point.
//
// Usage:
// import initializeTestimonials from "../components/02-components/testimonials/testimonials";
// import initializeAccordion from "../components/04-base/accordion/accordion";
//

//
// Below is the main function that gets called as soon as the DOM is
// ready.
//
// Usage:
// document.addEventListener('DOMContentLoaded', function () {
//   initializeTestimonials();
//   initializeAccordion();
// });
//

//document.addEventListener("DOMContentLoaded", function () {
initializeProductOverview();
initializeCart();
initializeHeaderSubnav();
initializeGtmTracking();
initializeProductDetail();
initializeCheckout();
initializeSearch();
//});
